<template>
  <div class="signin_page modal_card">
    <div class="signin_form modal_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1>Для корректной работы сайта, откройте страницу в другом браузере</h1>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>
